import { BaseTextFieldProps, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { FocusEvent, RefObject } from 'react';
import { Geocoding } from 'shared/geo/GeoHelpers';
import { useGeoFieldProps } from 'shared/geo/MapboxGeoField';

export interface AddressAutofillProps extends Pick<
  BaseTextFieldProps,
  | 'label'
  | 'fullWidth'
  | 'error'
  | 'helperText'
  | 'disabled'
  | 'placeholder'
  | 'autoFocus'
> {
  value: string;
  startIcon?: React.ReactNode;
  disableClearable?: boolean;
  onMouseOver?: () => void;
  onMouseLeave?: () => void;
  onBlur: (value: string) => void;
  onChange: (value: string) => void;
  onGeocode: (value: Geocoding | null) => void;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
  inputRef?: RefObject<HTMLInputElement>;
}

export function AddressAutofill({
  value,
  onBlur,
  onFocus,
  onChange,
  onGeocode,
  disabled,
  startIcon,
  onMouseOver,
  onMouseLeave,
  disableClearable = true,
  inputRef,
  ...textFieldProps
}: AddressAutofillProps) {
  const geoFieldProps = useGeoFieldProps({
    types: ['place', 'region', 'postcode', 'address'],
    formatOptionLabel: (option) => option.place_name || '',
  });

  return (
    <Autocomplete
      {...geoFieldProps}
      freeSolo={true}
      multiple={false}
      selectOnFocus={true}
      autoHighlight={true}
      disableClearable={disableClearable}
      value={value || ''}
      inputValue={value || ''}
      onInputChange={(...args) => {
        geoFieldProps.onInputChange?.(...args);
        onChange(args[1]);
      }}
      disabled={disabled}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onBlur={(event: FocusEvent<HTMLInputElement>) => {
        onBlur(event.target.value);
      }}
      onChange={(_, nextValue) => {
        if (typeof nextValue == 'string') {
          onChange(nextValue);
        } else {
          onGeocode(nextValue);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          inputRef={inputRef}
          inputProps={{ ...params.inputProps, autoComplete: 'new-password' }}
          InputProps={{ ...params.InputProps, startAdornment: startIcon }}
        />
      )}
    />
  );
}
